import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { TemplatesServices } from "../../../../services/templates";
import { MenuServices } from "../../../services";
import { ConfigurationServices } from '../../../../configuration/services';

/**
 * Generated class for the MenuPageCustomizeTemplatPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-menu-partial-customize-template',
  templateUrl: 'menu-page-customize-template.html',
})
export class MenuPageCustomizeTemplatPage {
  menu_uid: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public templateServices: TemplatesServices,
    public menuServices: MenuServices,
    public configurationServices: ConfigurationServices) {
    this.menu_uid = this.navParams.get('menu_uid');

  }

  ionViewWillEnter() {
    this.templateServices.getListBasic();
    //this.templateServices.getListNadal();
  }

  update(value) {
    //cambiar fondo
    this.menuServices.afs.collection('menus').doc(this.menu_uid).update({
      'template': value,
    }).then(() => {
      this.navCtrl.pop();
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/menu/menu-view/menu-partial-customize-options/menu-page-customize-template/menu-page-customize-template.ts